<div *ngIf="error" class="margin-10">
<div class="alert alert-danger row-flex align-center-start-flex" role="alert" div>
  <div><mat-icon>warning</mat-icon></div>
  <div>
    <strong>&nbsp;There was a problem running the survey.</strong>
  </div>
</div>
<div *ngIf="isTester()" class="alert alert-secondary column-flex align-center-start-flex" role="alert" div>
  <div>
    <br />
    <div [innerHTML]="errorMsg"></div>
  </div>
  <div>
    &nbsp;
  </div>
  <div>
    For more information <a (click)="getDetails()">click here</a>
  </div>
  <div>
    To Report it download <a (click)="download()">this file</a> and attach it to a <a href="https://github.com/OnePointGlobal/Frodo/issues" target="_blank"><img class="intrvw-prvw-github-img" src="../../assets/img/Github.png" />&nbsp;GitHub Issue</a>
  </div>
  <div>
    &nbsp;
  </div>
</div>
<div [@detailExpand]="edit === true ? 'expanded' : 'collapsed'">
  <div *ngIf="edit === true" class="alert alert-secondary" role="alert">
    <strong>Editor Interview Model</strong>&nbsp;<button mat-icon-button (click)="copyModel()"><mat-icon>content_copy</mat-icon></button>
    <pre class="intrvw-prvw-json-string">{{jsonString}}</pre>
  </div>
  <div *ngIf="edit === true" class="alert alert-secondary" role="alert">
    <strong>OneScript Source</strong>&nbsp;<button mat-icon-button (click)="copyScript()"><mat-icon>content_copy</mat-icon></button>
    <div [innerHTML]="errorDetail" class="intrvw-prvw-onescript-errorDtl"></div>
  </div>
</div>
</div>
<mat-tab-group mat-stretch-tabs="false" [selectedIndex]="selectedIndex" mat-align-tabs="start" *ngIf="!error">
<mat-tab *ngIf="isEmbed" label="Embedded Data">
  <div *ngIf="!started" style="margin-top: 5px">
    <button mat-flat-button color="primary" (click)="restartSurvey()">Start</button>&nbsp;
    <button mat-stroked-button (click)="showScript()">Show Script</button>&nbsp;
  </div>
  <div [formGroup]="embedForm" style="background:white;margin:10px;padding:10px">
    <div *ngFor="let question of embeddedQuestions; let i = index" formArrayName="values" style="margin:10px auto;width:100%">
      <div class="fieldRow" [formGroupName]="i" style="width:100%">
        <div style="width:20%">
          {{question.QuestionName}}&nbsp;
        </div>
        <div style="width:80%">
          <mat-form-field appearance="outline" style="width:100%">
            <mat-label> Value </mat-label>
            <input matInput placeholder="Value" formControlName="value">
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</mat-tab>
<mat-tab #spanel label="Survey">
      <div class="mb-5 fullWidth row-flex align-center-center-flex" style="margin-top: 10px;">
        <div class="auto-flex">
          <button mat-flat-button color="primary" (click)="restartSurvey()">Restart</button>&nbsp;
          <button mat-stroked-button (click)="showScript()">Show Script</button>&nbsp;
        </div>
        <div *ngIf="!isReview">
          <mat-button-toggle-group name="device" [(ngModel)]="deviceType" aria-label="Device Type">
            <mat-button-toggle value="desktop" (click)="runOnDesktop()">
              <mat-icon>desktop_windows</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="tablet" (click)="runOnTablet()">
              <mat-icon>tablet_mac</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="mobile" (click)="runOnMobile()">
              <mat-icon>phone_android</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="sms" (click)="runAsSms()">
              <mat-icon>sms</mat-icon>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
      <div *ngIf="!isSms" class="fullWidth" style="background:white">
        <div class="display-flex align-center-center-flex fullWidth">
            <diy-player class="scroller" #player [show]="show" [model]="model" [preview]="false" (navigate)="navigateQuestions($event)"
                        (changeLanguage)="languageChanged($event)" [playerWidth]="width" [ngClass]="selectedTheme" [style]="width == 9999 ? 'width:100%' : ''"></diy-player>
        </div>
      </div>
      <div *ngIf="isSms" class="halfWidth" style="background:white;margin:10px auto;padding: 10px 10px 75px 10px">
        <div class="column-flex align-center-center-flex fullWidth">
            <div class="intrvw-prvw-imessage" *ngFor="let message of messages; let i = index">
              <p *ngIf="whenFormatted(i) !=''" class="intrvw-prvw-messageDate">
                {{ whenFormatted(i) }}
              </p>
              <p *ngIf="message.Type == 1" class="intrvw-prvw-from-them">
                {{ message.Message }}
              </p>
              <p *ngIf="message.Type == 2" class="intrvw-prvw-from-me">
                {{ message.Message }}
              </p>
              <div *ngIf="i + 1 == messages.length">{{ scrollToBottom(i) }}</div>
            </div>
          </div>
          <div [formGroup]="form" class="intrvw-prvw-txtMsg-div" style="float:right;">
            <mat-form-field appearance="outline" class="fullWidth">
              <mat-label>Text Message</mat-label>
              <div class="row-flex">
                <div class="wd-90-per">
                  <textarea matInput formControlName="message" class="scroll fullWidth"
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="10"></textarea>
                </div>
                <div class="display-flex align-center-start-flex">
                  <button mat-icon-button color="primary" (click)="sendSms()">
                    <mat-icon>arrow_circle_up</mat-icon>
                  </button>
                </div>
              </div>
            </mat-form-field>
          </div>
        </div>
  </mat-tab>
</mat-tab-group>
<ng-template #scriptDialog>
  <div class="user-details-dialog-container">
    <div class="leftFloat">
      <h3>OneScript</h3>
    </div>
    <div class="rightFloat">
      <button mat-icon-button (click)="copyScript()" matTooltip="Copy to Clipboard"><mat-icon>content_copy</mat-icon></button>
      <button mat-icon-button matDialogClose="no" matTooltip="Close" matTooltipPosition="below">
        <mat-icon class="user-details-dialog-close-icon">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="intrvw-prvw-onescript-errorDtl" style="background: white;margin-top:5px;height:100%">
    <div [innerHTML]="errorDetail"  style="height:100%"></div>
  </div>
</ng-template>

